module.exports = __webpack_public_path__ + "static/GORETEX-e9e013871d49833aa064325061597fdf.svg";